/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CMSSearchIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CMSSearchIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 1C8.31121 1 9.5231 1.294 10.4248 1.79492C11.3096 2.28647 12 3.04561 12 4V7H11V5.82129C10.8224 5.96255 10.6292 6.0915 10.4248 6.20508C9.5231 6.706 8.31121 7 7 7C5.68879 7 4.4769 6.706 3.5752 6.20508C3.37076 6.0915 3.17756 5.96255 3 5.82129V7C3 7.42631 3.31669 7.91778 4.06055 8.33105C4.78751 8.73492 5.82597 9 7 9V10C5.68879 10 4.4769 9.706 3.5752 9.20508C3.37076 9.0915 3.17756 8.96255 3 8.82129V10C3 10.4263 3.31669 10.9178 4.06055 11.3311C4.78751 11.7349 5.82597 12 7 12V13C5.68879 13 4.4769 12.706 3.5752 12.2051C2.69042 11.7135 2 10.9544 2 10V4C2 3.04561 2.69042 2.28647 3.5752 1.79492C4.4769 1.294 5.68879 1 7 1ZM7 2C5.82597 2 4.78751 2.26508 4.06055 2.66895C3.31669 3.08222 3 3.57369 3 4C3 4.42631 3.31669 4.91778 4.06055 5.33105C4.78751 5.73492 5.82597 6 7 6C8.17403 6 9.21249 5.73492 9.93945 5.33105C10.6833 4.91778 11 4.42631 11 4C11 3.57369 10.6833 3.08222 9.93945 2.66895C9.21249 2.26508 8.17403 2 7 2Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.585 11.8779C12.8465 11.4828 13 11.0093 13 10.5C13 9.11929 11.8807 8 10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.0093 13 11.4828 12.8465 11.8779 12.585L13.6465 14.3535L14.3535 13.6465L12.585 11.8779ZM10.5 9C11.3284 9 12 9.67157 12 10.5C12 10.9144 11.8325 11.2886 11.5605 11.5605C11.2886 11.8325 10.9144 12 10.5 12C9.67157 12 9 11.3284 9 10.5C9 9.67157 9.67157 9 10.5 9Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CMSSearchIcon.tags = [
  'collection',
  'coins',
  'stack',
  'database',
  'magnifying',
  'find',
  'search',
  'zoom',
];

CMSSearchIcon.category = 'General Icons';

CMSSearchIcon.iconSize = 16;
